import { ApiMethodItems } from '../api/utils/fetchControlApiMethodOptions';
import { ControlItems } from '../types/types';

// Type guard: narrows ControlItems to ApiMethodItems (dynamic fetch via apiMethod)
export const isApiMethodItems = (
  items: ControlItems
): items is ApiMethodItems => {
  return (
    items !== null &&
    typeof items === 'object' &&
    !Array.isArray(items) &&
    'apiMethod' in items
  );
};
